import moment from 'moment';
import { IDocumentData } from './IDocuments';

type GroupedDocuments = {
  [index: string]: IDocumentData[] | undefined;
};

export const groupDocumentsByYear = (docs: IDocumentData[]): GroupedDocuments =>
  docs.reduce((result, currentDoc) => {
    const year = moment(currentDoc.createdAt).get('year').toString();
    const hasPreviousData = result[year]?.length;

    return {
      ...result,
      [year]: hasPreviousData ? [...result[year]!, currentDoc] : [currentDoc],
    };
  }, {} as GroupedDocuments);

export const sortByDate = (docs: IDocumentData[]) =>
  docs.sort((a, b) => moment(b.createdAt).unix() - moment(a.createdAt).unix());
